import http from '../helpers/http';

export default class ThemeRepository {
    getTheme() {
        return http.get('/public/themes/theme.json').then(theme => { return { data: theme } })
    }
}